import React from "react";
import { Button, CircularProgress, Tooltip } from "@mui/material";
import { icons } from "../../../../svg";

interface KochDlvdMode {
  truck: "px" | "alt";
  rail: "px" | "alt";
}

interface AllOriginsHeaderProps {
  dlvdOfferInput: string;
  onDlvdOfferChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onResetClick: () => void;
  kochDlvdMode: KochDlvdMode;
  onKochDlvdModeChange: (mode: KochDlvdMode) => void;
  isSavingDlvdOptions?: boolean;
}

const AllOriginsHeader: React.FC<AllOriginsHeaderProps> = ({
  dlvdOfferInput,
  onDlvdOfferChange,
  onResetClick,
  kochDlvdMode,
  onKochDlvdModeChange,
  isSavingDlvdOptions = false,
}) => {
  return (
    <div id="all-origin-header" className="filter-input-wrapper">
      {/* Left: DLVD Offer input */}
      <div className="all-origins-dlvd-offer-col">
        <span className="all-origins-col-label">DLVD Offer</span>
        <div className="input-box input-box-inline-layout">
          <span className="dlvd-offer-input">$</span>
          <input
            id="dlvd-offer-input"
            type="number"
            className="dlvd-offer-input dlvd-offer-text"
            value={dlvdOfferInput}
            onChange={onDlvdOfferChange}
          />
          {dlvdOfferInput && (
            <Tooltip title="reset to FOB price" arrow>
              <Button
                size="small"
                variant="text"
                id="dlvd-offer-refresh-button"
                onClick={onResetClick}
                className="refresh-button"
              >
                <img
                  src={icons.RefreshButtonIcon}
                  alt="MultiLocations Refresh Icon"
                  className="refresh-icon"
                />
              </Button>
            </Tooltip>
          )}
        </div>
      </div>

      {/* Right: Koch DLVD Offer */}
      <div
        id="all-origins-koch-dlvd-offer-selection"
        className="all-origins-koch-dlvd-col"
      >
        <span
          className="all-origins-col-label"
          style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
        >
          Koch DLVD Offer
          {isSavingDlvdOptions ? <CircularProgress size={11} /> : null}
        </span>
        <div className="koch-dlvd-rows">
          <div className="koch-dlvd-row">
            <span id="koch-dlvd-truck-label" className="koch-dlvd-mode-label">
              Truck
            </span>
            <div id="koch-dlvd-truck-btns" className="koch-dlvd-btns">
              <button
                id="koch-dlvd-truck-px-btn"
                type="button"
                disabled={isSavingDlvdOptions}
                className={`koch-dlvd-btn ${
                  kochDlvdMode.truck === "px" ? "active" : ""
                }`}
                onClick={() =>
                  onKochDlvdModeChange({ ...kochDlvdMode, truck: "px" })
                }
              >
                Px
              </button>
              <button
                id="koch-dlvd-truck-alt-btn"
                type="button"
                disabled={isSavingDlvdOptions}
                className={`koch-dlvd-btn ${
                  kochDlvdMode.truck === "alt" ? "active" : ""
                }`}
                onClick={() =>
                  onKochDlvdModeChange({ ...kochDlvdMode, truck: "alt" })
                }
              >
                ALT
              </button>
            </div>
          </div>
          <div className="koch-dlvd-row">
            <span id="koch-dlvd-rail-label" className="koch-dlvd-mode-label">
              Rail
            </span>
            <div id="koch-dlvd-rail-btns" className="koch-dlvd-btns">
              <button
                id="koch-dlvd-rail-px-btn"
                type="button"
                disabled={isSavingDlvdOptions}
                className={`koch-dlvd-btn ${
                  kochDlvdMode.rail === "px" ? "active" : ""
                }`}
                onClick={() =>
                  onKochDlvdModeChange({ ...kochDlvdMode, rail: "px" })
                }
              >
                Px
              </button>
              <button
                id="koch-dlvd-rail-alt-btn"
                type="button"
                disabled={isSavingDlvdOptions}
                className={`koch-dlvd-btn ${
                  kochDlvdMode.rail === "alt" ? "active" : ""
                }`}
                onClick={() =>
                  onKochDlvdModeChange({ ...kochDlvdMode, rail: "alt" })
                }
              >
                ALT
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllOriginsHeader;
